import { memo } from "react";

export const MerchantCreatedDetails = memo(function MerchantCreatedDetails() {
  return null;
});
